export const isNotNull = <T>(item: T | null | undefined): item is T => item !== null && item !== undefined
export const isNotEmpty = <T>(item: T | null | undefined): item is T => isNotNull(item) && item !== ''
